export default __webpack_public_path__ + "0a7858527792b90a08506bf5161bbcf8.svg";